// extracted by mini-css-extract-plugin
export default {"root":"mobile-page_root__cm6ZW"};